import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SafeArea } from 'antd-mobile';
import PriceForm from './components/PriceForm';
import PriceList from './components/PriceList';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import SharedRoute from './components/SharedRoute';
import { AuthProvider } from './context/AuthContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <SafeArea position="top" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <PrivateRoute>
                <PriceForm />
              </PrivateRoute>
            } />
            <Route path="/list" element={
              <PrivateRoute>
                <PriceList />
              </PrivateRoute>
            } />
            {/* 简化分享路由，使用相同的组件 */}
            <Route path="/share/:shareId" element={
              <SharedRoute children={undefined} />
              } />
          </Routes>
          <SafeArea position="bottom" />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
